import { combineReducers } from 'redux'

import priorityTaskReducer from './priority-task-reducer'
import priorityTasksReducer from './priority-tasks-reducer'

export default combineReducers({
  priorityTasks: priorityTasksReducer,
  priorityTask: priorityTaskReducer,
})
